import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));
const LLabel = styled('span')({
    marginLeft: '4px',
    textAlign: 'left',
    display: 'inline-block',
    fontSize: '0.8rem !important',
    top: 0,
    left: 0,
    color: 'rgba(0,0,0,0.6)'
});
export  {Item,LLabel};